import React, { useContext, useEffect, useState } from "react";
//
import { useNavigate } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";
// ui
import Box from "@mui/material/Box";
import PhotoIcon from "@mui/icons-material/Photo";
import PhotoCameraBackIcon from "@mui/icons-material/PhotoCameraBack";
import ArticleIcon from "@mui/icons-material/Article";
import Typography from "@mui/material/Typography";
//
import ButtonPopup from "../../../../../../../common/components/popup/ButtonPopup";
import ButtonBadgePopup from "../../../../../../../common/components/popup/ButtonBadgePopup";
import ButtonMain from "../../../../../../../common/components/button/ButtonMain";
import useModulePublic from "../../../../../../hooks/useModulePublic";
import ImageMineType from "./subComp/ImageMineType";
import ImageResolution from "./subComp/ImageResolution";
import FileMineType from "./subComp/FileMineType";
import ExportProcess from "./subComp/ExportProcess";
// store
import { StoreContext } from "../../../../../../../store/StoreProvider";
import Act from "../../../../../../../store/actions";
//
// config,utils
// style
import { MODULE_ID } from "../../../../../../../config/CONSTANTS";
import exportIcon from "../../../../../../../../images/icon_export/icon_export_dark/匯出.svg";

const popupMenuPosition = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "right",
  },
};

const ExportTool = () => {
  // props

  // route,intl
  const intl = useIntl();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const {
    fileMineType,
    imageResolution,
    imageMineType,
    startExportFile,
    startExportImage,
  } = sna.export || {};
  // local state
  const [popupPageIdx, setPopupPageIdx] = useState(0);
  const [popPageCtx, setPopPageCtx] = useState({});
  // hooks
  const { handlePublic } = useModulePublic();

  const handleDisabled = (moduleId) => !handlePublic(moduleId);

  const getPopupPage0 = () => ({
    body: [
      {
        children: (
          <Box px={3} py={2}>
            <Box mb={4}>
              <Typography variant="body2">
                <FormattedMessage
                  id="sna.topPanel.export.popup.title"
                  defaultMessage="匯出"
                />
              </Typography>
            </Box>
            <Box mb={2}>
              <ButtonMain
                buttonProps={{
                  text: intl.formatMessage({
                    id: "sna.topPanel.export.popup.export.image",
                    defaultMessage: "匯出圖片",
                  }),
                  startIcon: <PhotoCameraBackIcon />,
                  fullWidth: true,
                  variant: "gradient",
                  onClick: () => setPopupPageIdx(1),
                }}
              />
            </Box>
            <Box>
              <ButtonMain
                buttonProps={{
                  text: intl.formatMessage({
                    id: "sna.topPanel.export.popup.export.file",
                    defaultMessage: "匯出檔案",
                  }),
                  startIcon: <ArticleIcon />,
                  fullWidth: true,
                  variant: "gradient",
                  onClick: () => setPopupPageIdx(2),
                }}
              />
            </Box>
          </Box>
        ),
        useMenuItem: false,
      },
    ],
  });

  // 匯出圖片
  // fixme: disabledExportImage 更新後,UI 沒有跟著變動
  const disabledExportImage =
    !handlePublic(MODULE_ID.snaTopPanelExportImage) ||
    !imageMineType ||
    startExportImage;
  const handleExportImage = () => {
    dispatch({
      type: Act.SNA_EXPORT_START_EXPORT_IMAGE,
      payload: true,
    });
  };
  const getPopupPage1 = () => ({
    body: [
      {
        children: (
          <Box px={3} py={2}>
            <Box mb={4}>
              <Typography>
                <FormattedMessage
                  id="sna.topPanel.export.popup.export.image"
                  defaultMessage="匯出圖片"
                />
              </Typography>
            </Box>
            <Box mb={2}>
              <Box mb={1}>
                <ImageMineType />
              </Box>
              <Box mb={1}>
                <ImageResolution />
              </Box>
            </Box>
            <Box>
              <ButtonMain
                buttonProps={{
                  text: intl.formatMessage({
                    id: "sna.topPanel.export.popup.export.confirm",
                    defaultMessage: "匯出",
                  }),
                  disabled: disabledExportImage,
                  startIcon: <PhotoCameraBackIcon />,
                  fullWidth: true,
                  variant: disabledExportImage ? "disabled" : "gradient",
                  onClick: () => handleExportImage(),
                }}
              />
            </Box>
          </Box>
        ),
        useMenuItem: false,
      },
    ],
  });

  // 匯出檔案
  const disabledExportFile =
    !handlePublic(MODULE_ID.snaTopPanelExportFile) ||
    !fileMineType ||
    startExportFile;
  const handleExportFile = () => {
    dispatch({
      type: Act.SNA_EXPORT_START_EXPORT_FILE,
      payload: true,
    });
  };
  const getPopupPage2 = () => ({
    body: [
      {
        children: (
          <Box px={3} py={2}>
            <Box mb={4}>
              <Typography variant="body2">
                <FormattedMessage
                  id="sna.topPanel.export.popup.export.file"
                  defaultMessage="匯出檔案"
                />
              </Typography>
            </Box>
            <Box mb={2}>
              <Box mb={1}>
                <FileMineType />
              </Box>
            </Box>
            <Box>
              <ButtonMain
                buttonProps={{
                  text: intl.formatMessage({
                    id: "sna.topPanel.export.popup.export.confirm",
                    defaultMessage: "匯出",
                  }),
                  startIcon: <PhotoCameraBackIcon />,
                  disabled: disabledExportFile,
                  fullWidth: true,
                  variant: disabledExportFile ? "disabled" : "gradient",
                  onClick: () => handleExportFile(),
                }}
              />
            </Box>
          </Box>
        ),
        useMenuItem: false,
      },
    ],
  });

  // popup 所有分頁
  const popupPages = [getPopupPage0(), getPopupPage1(), getPopupPage2()];

  // 當選擇的 dataset 變更 or pageIdx 便更時, 重新產生 popup 內容
  useEffect(() => {
    setPopPageCtx(popupPages[popupPageIdx]);
  }, [popupPageIdx, sna.export]);

  const getMenuProps = () => ({
    ...popPageCtx,
    ...popupMenuPosition,
    onClose: () => setPopupPageIdx(0),
    sx: {
      "& .MuiPopover-paper": {
        minWidth: "248px",
      },
    },
  });

  return (
    <Box>
      <ExportProcess />
      <ButtonPopup
        buttonProps={{
          variant: "neutral",
          text: intl.formatMessage({
            id: "sna.topPanel.export",
            defaultMessage: "匯出",
          }),
          disabled: handleDisabled(MODULE_ID.snaTopPanelExport),
          startIcon: <img src={exportIcon} alt="exportIcon" />,
        }}
        menuProps={{
          ...getMenuProps(),
        }}
      />
    </Box>
  );
};

ExportTool.propTypes = {};

ExportTool.defaultProps = {};

export default ExportTool;
